<template>
  <v-autocomplete
    v-bind:value="modelValue"
    :items="ITENS_FILTRADOS"
    item-text="descricao"
    item-value="id"
    v-bind="$attrs"
    :auto-select-first="autoSelectFirst"
    :loading="loading"
    v-on="inputListeners"
  >
    <template v-slot:progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        :color="cor_loading"
        indeterminate
      ></v-progress-linear>
    </template>

    <template v-slot:prepend-item v-if="multiplaSelecao && items.length">
      <v-list-item
        v-if="modelValue.length === items.length"
        class="pl-14px py-2"
        @click="updateModelValue(multiplaSelecao ? [] : '')"
      >
        <v-icon color="primary" class="ml-2">mdi-checkbox-marked</v-icon>
        <span class="ml-2 font-weight-medium">Desmarcar Todos</span>
      </v-list-item>

      <v-list-item
        v-else
        class="pl-14px py-2"
        @click="updateModelValue(multiplaSelecao ? Helpers.arrayColumn(items, 'id') : '')"
      >
        <v-icon v-if="modelValue.length > 0" class="ml-2" color="primary">mdi-minus-box</v-icon>
        <v-icon v-else class="ml-2">mdi-checkbox-blank-outline</v-icon>
        <span class="ml-2 font-weight-medium">Selecionar Todos</span>
      </v-list-item>

      <v-divider />
    </template>

    <template v-slot:selection="{item}" v-if="multiplaSelecao">
      <div>
        <template v-if="modelValue.indexOf(item.id) < qtdeVisivelSelecionados">
          F{{ item.id }}
          <template v-if="apendarVirgula(item)">,&nbsp;</template>
        </template>

        <template v-if="modelValue.indexOf(item.id) === qtdeVisivelSelecionados">
          <span class="ml-1 text-grat-900">(+ {{ modelValue.length - qtdeVisivelSelecionados }})</span>
        </template>
      </div>
    </template>

    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>

    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>

    <template #append-outer>
      <GrupoFilialComprasDinamicosDialog
        v-if="config_compras_exibir_grupo_compras_usuario_ativo"
        class="mt-n2"
        desabilitar_opcao_processamento_fornecedor
        @processamento:finalizado="grupoComprasUsuarioConfigurado"
      />
    </template>
  </v-autocomplete>
</template>

<script>
import FilialAPI from "@/api/filial"
import { arrayColumn } from "@/helpers";
import GrupoFilialComprasDinamicosDialog from "@/components/compra/ProdutosGerais/Filtros/GrupoFilialComprasDinamicosDialog/Index.vue";

export default {
  name: "SysFilialGrupoAutocomplete",
  components: {
    GrupoFilialComprasDinamicosDialog,
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  emits: ["change", "update:modelValue", "processamento:finalizado"],
  props: {
    modelValue: {
      type: [Number, String, Array],
      required: true
    },
    idGrupo: [Number, String],
    idsGrupo: Array,
    qtdeVisivelSelecionados: {
      type: [Number],
      default: 1
    },
    unshiftItems: {
      type: Object,
      default: () => ({})
    },
    filiais_para_ocultar: {
      type: Array,
      default: () => ([])
    },
    autoSelectFirst: {
      type: Boolean,
      default: false
    },
    cor_loading: {
      type: String,
      default: 'red'
    },
    filiais_destino_drp: Array,
    auto_selecao_filiais_grupo: {
      type: Boolean,
      default: false
    },
    selecionar_filial_matriz_do_grupo: {
      type: Boolean,
      default: false
    },
    config_compras_exibir_grupo_compras_usuario_ativo: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    items: [],
    loading: false,
    timer_buscar_items: null,
  }),
  computed: {
    inputListeners: function () {
      var vm = this

      return Object.assign({},
        this.$listeners,
        {
          input: function (event) {
            vm.updateModelValue(event)
          }
        }
      )
    },
    multiplaSelecao() {
      return ![false, null, undefined].includes(this.$attrs.multiple)
    },
    itens_final() {
      if (this.unshiftItems && this.unshiftItems.id !== undefined) {
        return [this.unshiftItems].concat(this.items);
      }

      return this.items;
    },
    ITENS_FILTRADOS() {
      if (this.filiais_para_ocultar && this.filiais_para_ocultar.length > 0) {
        return this.itens_final.filter(item => !this.filiais_para_ocultar.includes(item.id));
      }

      return this.itens_final;
    }
  },
  watch: {
    idGrupo() {
      this.items = [];

      if (this.idGrupo > 0) {
        this.getItems();
      }
    },
    idsGrupo() {
      clearTimeout(this.timer_buscar_items);
      this.timer_buscar_items = setTimeout(this.getItems, 2000);
    },
    items() {
      this.$emit('items', this.items);
    },
    modelValue(valor_antigo, valor_novo) {
      if (String(valor_antigo) !== String(valor_novo)) {
        this.$emit("change", {})
      }
    }
  },
  mounted() {
    this.getItems();
  },
  methods: {
    updateModelValue(newValue) {
      this.$emit("update:modelValue", newValue)
    },
    getItems() {
      this.loading = true
      const headers = this.Helpers.iniciarRequisicao()

      let grupos = [];

      if (this.idsGrupo && this.idsGrupo.length > 0) {
        grupos = this.idsGrupo;
      } else if (this.idGrupo > 0) {
        grupos = [this.idGrupo];
      }

      const params = {
        grupos,
        filiais_destino_drp: this.filiais_destino_drp,
      };

      FilialAPI.getFiliaisGrupo(headers, params)
      .then((response) => {
        const { token, filiais } = response.data
        localStorage.token = token
        this.items = filiais
        this.loading = false

        if (this.autoSelectFirst && filiais.length > 0) {
          this.updateModelValue(filiais[0].id);
        }

        this.atualizarFiliaisSelecionadas();

        if (this.auto_selecao_filiais_grupo) {
          this.updateModelValue(arrayColumn(filiais, 'id'));
        }

        if (this.selecionar_filial_matriz_do_grupo) {
          const grupo_id = Number(this.idGrupo);
          const filial_matriz = filiais.find(f => f.matriz === 'S' && Number(f.id_grupo) === grupo_id);

          if (filial_matriz) {
            this.updateModelValue(filial_matriz.id);
          }
        }
      })
      .catch(() => this.Helpers.logout()
      )
    },
    atualizarFiliaisSelecionadas() {
      if (!this.multiplaSelecao || !Array.isArray(this.modelValue)) return;

      if (!this.modelValue.length) return;

      const filiais = this.items.filter(filial => this.modelValue.some(id => `${id}` === `${filial.id}`));
      this.updateModelValue(arrayColumn(filiais, 'id'));
    },
    apendarVirgula(item) {
      const indexOf = this.modelValue.indexOf(item.id)
      return indexOf !== (this.modelValue.length - 1) && indexOf < (this.qtdeVisivelSelecionados - 1)
    },
    grupoComprasUsuarioConfigurado() {
      this.$emit('processamento:finalizado', {})
      this.getItems();
    }
  }
}
</script>

<style scoped>
.pl-14px {
  padding-left: 14px
}

.text-grat-900 {
  color: #999;
}
</style>
